import { ColourPreviewCombinedProps } from './types';

const usePresenter = (props: ColourPreviewCombinedProps): ColourPreviewCombinedProps => {
  return props;
};

export default usePresenter;
